import { useEffect } from 'react';

/** Release background work only after the successful first-page commit has had a paint opportunity. */
export function useInitialMailRender(ready: boolean, onRendered: () => void) {
  useEffect(() => {
    if (!ready) return;
    let second: number | undefined;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(onRendered);
    });
    return () => {
      cancelAnimationFrame(first);
      if (second !== undefined) cancelAnimationFrame(second);
    };
  }, [ready, onRendered]);
}
